import Vue from 'vue'
import Router from 'vue-router'
// in development env not use Lazy Loading,because Lazy Loading too many pages will cause webpack hot update too slow.so only in production use Lazy Loading
/* layout */
import Layout from "../views/layout/Layout.vue";

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
 roles: ['admin','editor']    control the page roles (you can set multiple roles)
 title: 'title'               the name show in sidebar and breadcrumb (recommend set)
 icon: 'svg-name'             the icon show in the sidebar
 noCache: true                if set true, the page will no be cached(default is false)
 affix: true                  if set true, the tag will affix in the tags-view
 breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
 activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
 }
 */

const _import = require('./_import_' + process.env.NODE_ENV)
Vue.use(Router)
export const constantRouterMap = [
  {
    path: '/',
    component: Layout,
    redirect: '/workspace/overview',
    name: '首页',
    hidden: true,
    meta: {
      title: '首页',
      icon: 'bb',
      affix: true
    }
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [{
      path: '/redirect/:path(.*)',
      component: () => import('@/views/redirect/index')
    }]
  },
  {
    path: '/home',
    component: _import('404'),
    hidden: true
  },
  {
    path: '/login',
    component: _import('login/login'),
    hidden: true
  },
  {
    path: '/404',
    component: _import('404'),
    hidden: true
  },
]
export const asyncRouterMap = [
  {
    name: "工作台",
    path: '/workspace',
    component: Layout,
    meta: {
      icon: 'bb',
      hoverIcon: 'bb-h',
    },
    allowShow: true,
    children: [
      {
        name: '工作台概览',
        path: 'overview',
        component: _import('dashboard/overview/index'),
        meta: {
          title: '工作台概览',
          icon: 'bb',
          hoverIcon: 'bb-h',
        },
        menu: 'overview'
      },
    ]
  },
  {
    name: "基础资料",
    path: '/user',
    component: Layout,
    meta: {
      icon: 'jichuziliao',
      hoverIcon: 'jichuziliao-h',
    },
    children: [
      {
        name: '企业信息',
        path: 'enterprise',
        component: _import('enterprise/index'),
        icon: 'qiyexinxi',
        hoverIcon: 'qiyexinxi-h',
        meta: {
          title: '企业信息',
          icon: 'qiyexinxi',
          hoverIcon: 'qiyexinxi-h',
        },
        menu: 'enterprise'
      },
      {
        name: '组织管理',
        path: 'organization',
        component: _import('organization/index'),
        icon: 'zuzhiguanli',
        hoverIcon: 'zuzhiguanli-h',
        meta: {
          title: '组织管理',
          icon: 'zuzhiguanli',
          hoverIcon: 'zuzhiguanli-h',
        },
        menu: 'organization'
      },
      {
        name: '角色权限',
        path: 'role',
        component: _import('role/index'),
        icon: 'jiaosequanxian',
        hoverIcon: 'jiaosequanxian-h',
        meta: {
          title: '角色权限',
          icon: 'jiaosequanxian',
          hoverIcon: 'jiaosequanxian-h',
        },
        menu: 'role'
      },
      {
        name: '司机档案',
        path: 'driver',
        component: _import('driver/index'),
        icon: 'sijidakuan',
        hoverIcon: 'sijidakuan-h',
        meta: {
          title: '司机档案',
          icon: 'sijidakuan',
          hoverIcon: 'sijidakuan-h',
        },
        menu: 'driver'
      },
      {
        name: '司机详情',
        path: 'driver/detail/:id',
        component: _import('driver/detail'),
        hidden: true,
        meta: {
          title: '司机详情',
        }
      },
      {
        name: '新增司机',
        path: 'driver/add',
        component: _import('driver/add'),
        hidden: true,
        meta: {
          title: '新增司机',
        }
      },
      {
        name: '编辑司机',
        path: 'driver/edit/:id',
        component: _import('driver/edit'),
        hidden: true,
        meta: {
          title: '编辑司机',
        }
      },
      {
        name: '车辆档案',
        path: 'vehicle',
        component: _import('vehicle/index'),
        icon: 'cheliangdangan',
        hoverIcon: 'cheliangdangan-h',
        meta: {
          title: '车辆档案',
          icon: 'cheliangdangan',
          hoverIcon: 'cheliangdangan-h',
        },
        menu: 'vehicle'
      },
      {
        name: '车辆详情',
        path: 'vehicle/detail/:id',
        component: _import('vehicle/detail'),
        hidden: true,
        meta: {
          title: '车辆详情',
        }
      },
      {
        name: '新增车辆',
        path: 'vehicle/add',
        component: _import('vehicle/add'),
        hidden: true,
        meta: {
          title: '新增车辆',
        }
      },
      {
        name: '编辑车辆',
        path: 'vehicle/edit/:id',
        component: _import('vehicle/edit'),
        hidden: true,
        meta: {
          title: '编辑车辆',
        }
      },
      {
        name: '证件管理',
        path: 'certificate',
        component: _import('certificate/index'),
        icon: 'zhengjianguanli',
        hoverIcon: 'zhengjianguanli-h',
        meta: {
          title: '证件管理',
          icon: 'zhengjianguanli',
          hoverIcon: 'zhengjianguanli-h',
        },
        menu: 'certificate'
      },
      {
        name: '新增证件',
        path: 'certificate/add',
        component: _import('certificate/add'),
        hidden: true,
        meta: {
          title: '新增证件',
        }
      },
      {
        name: '编辑证件',
        path: 'certificate/edit/:id',
        component: _import('certificate/edit'),
        hidden: true,
        meta: {
          title: '编辑证件',
        }
      },
      {
        name: '证件详情',
        path: 'certificate/detail/:id',
        component: _import('certificate/detail'),
        hidden: true,
        meta: {
          title: '证件详情',
        }
      },
    ]
  },
  {
    name: "任务管理",
    path: '/task',
    component: Layout,
    meta: {
      icon: 'renwu',
      hoverIcon: 'renwu-h',
    },
    allowShow: true,
    children: [
      {
        name: '任务单',
        path: 'index',
        component: _import('task/index'),
        icon: 'renwu',
        hoverIcon: 'renwu-h',
        meta: {
          title: '任务单',
          icon: 'renwu',
          hoverIcon: 'renwu-h',
        },
        menu: 'task'
      },
      {
        name: '订单',
        path: 'order',
        component: _import('task/order'),
        icon: 'dingdan',
        hoverIcon: 'dingdan-h',
        meta: {
          title: '订单',
          icon: 'dingdan',
          hoverIcon: 'dingdan-h',
        },
        menu: 'orderManage'
      },
      {
        name: '订单详情',
        path: 'order/detail/:id',
        component: _import('task/order-detail'),
        hidden: true,
        meta: { title: '订单详情' }
      },
      {
        name: '新增订单',
        path: 'order/detail/add',
        component: _import('task/order-detail'),
        hidden: true,
        meta: { title: '新增订单' }
      },
      {
        name: '任务补录',
        path: 'supplement',
        component: _import('task/supplement/index'),
        hidden: true,
        meta: {
          title: '任务补录',
          icon: 'jilu',
          hoverIcon: 'jilu-h',
        },
        menu: 'taskSupplement'
      },
      {
        name: '补录详情',
        path: 'supplement/:id',
        component: _import('task/supplement/detail'),
        hidden: true,
        meta: {
          title: '补录详情',
        }
      },
      {
        name: '新增补录',
        path: 'supplement/add',
        component: _import('task/supplement/add'),
        hidden: true,
        meta: {
          title: '新增补录',
        }
      },
      {
        name: '编辑补录',
        path: 'supplement/edit/:id',
        component: _import('task/supplement/edit'),
        hidden: true,
        meta: {
          title: '编辑补录',
        }
      },
      {
        name: '补录日常任务',
        path: 'supplement/daily/add',
        component: _import('task/supplement/daily'),
        hidden: true,
        meta: {
          title: '补录日常任务',
        }
      },
      {
        name: '补录固定任务',
        path: 'supplement/fixed/add',
        component: _import('task/supplement/fixed'),
        hidden: true,
        meta: {
          title: '补录固定任务',
        }
      },
      {
        name: '新增任务',
        path: 'add',
        component: _import('task/add'),
        hidden: true,
        meta: {
          title: '新增任务',
        },
      },
      {
        name: '编辑任务',
        path: 'edit/:id',
        component: _import('task/edit'),
        hidden: true,
        meta: {
          title: '编辑任务',
        },
      },
      {
        name: '任务详情',
        path: 'detail/:id',
        component: _import('task/detail'),
        hidden: true,
        meta: {
          title: '任务详情',
        },
      },
      {
        name: '拆单操作',
        path: 'split/:id',
        component: _import('task/split/detail'),
        hidden: true,
        meta: {
          title: '拆单操作',
        },
      },
      {
        name: '拆单查看',
        path: 'split/view/:id',
        component: _import('task/split/view'),
        hidden: true,
        meta: {
          title: '拆单查看',
        },
      },
      {
        name: '子任务列表',
        path: 'split/sub-tasks',
        component: _import('task/split/sub-tasks'),
        hidden: true,
        meta: {
          title: '子任务列表',
        },
      },
      {
        name: '每日出车检查',
        path: 'inspection',
        component: _import('task/inspection/index'),
        meta: {
          title: '每日出车检查',
          icon: 'cheliang',
          hoverIcon: 'cheliang-h',
        },
        menu: 'dispatchInspection'
      },
      {
        name: '出车检查详情',
        path: 'inspection/detail/:id',
        component: _import('task/inspection/detail'),
        hidden: true,
        meta: {
          title: '出车检查详情',
        }
      },
      {
        name: '车检隐患处置',
        path: 'hazard',
        component: _import('task/hazard/index'),
        meta: {
          title: '车检隐患处置',
          icon: 'cheliang',
          hoverIcon: 'cheliang-h',
        },
        menu: 'inspectionHazard'
      },
      {
        name: '隐患详情',
        path: 'hazard/detail/:id',
        component: _import('task/hazard/detail'),
        hidden: true,
        meta: {
          title: '隐患详情',
        }
      },
      {
        name: '隐患处置',
        path: 'hazard/dispose/:id',
        component: _import('task/hazard/dispose'),
        hidden: true,
        meta: {
          title: '隐患处置',
        }
      },
      {
        name: '车辆介质上报',
        path: 'medium-report',
        component: _import('task/medium-report/index'),
        meta: {
          title: '车辆介质上报',
          icon: 'cheliang',
          hoverIcon: 'cheliang-h',
        },
        menu: 'vehicleMediumReport'
      },
      {
        name: '新增介质上报',
        path: 'medium-report/add',
        component: _import('task/medium-report/add'),
        hidden: true,
        meta: { title: '新增介质上报' }
      },
      {
        name: '介质上报详情',
        path: 'medium-report/detail/:id',
        component: _import('task/medium-report/detail'),
        hidden: true,
        meta: { title: '介质上报详情' }
      },
      {
        name: '每日工单上报',
        path: 'daily-work-order',
        component: _import('task/daily-work-order/index'),
        meta: {
          title: '每日工单上报',
          icon: 'cheliang',
          hoverIcon: 'cheliang-h',
        },
        menu: 'dailyWorkOrder'
      },
      {
        name: '新增工单上报',
        path: 'daily-work-order/add',
        component: _import('task/daily-work-order/add'),
        hidden: true,
        meta: { title: '新增工单上报' }
      },
      {
        name: '编辑工单上报',
        path: 'daily-work-order/edit/:id',
        component: _import('task/daily-work-order/edit'),
        hidden: true,
        meta: { title: '编辑工单上报' }
      },
      {
        name: '工单上报详情',
        path: 'daily-work-order/detail/:id',
        component: _import('task/daily-work-order/detail'),
        hidden: true,
        meta: { title: '工单上报详情' }
      },
    ]
  },
  {
    name: "调度中心",
    path: '/dispatch',
    component: Layout,
    meta: {
      icon: 'paidan',
      hoverIcon: 'paidan-h',
    },
    allowShow: true,
    children: [
      {
        name: '调度总控台',
        path: 'console',
        component: _import('dispatch/console/index'),
        meta: {
          title: '调度总控台',
          icon: 'paidan',
          hoverIcon: 'paidan-h',
        },
        menu: 'dispatchConsole'
      },
      {
        name: '改派/换车',
        path: 'change',
        component: _import('dispatch/change/index'),
        meta: {
          title: '改派/换车',
          icon: 'dingdan',
          hoverIcon: 'dingdan-h',
        },
        menu: 'dispatchChange'
      },
      {
        name: '改派/换车详情',
        path: 'change/detail/:id',
        component: _import('dispatch/change/detail'),
        hidden: true
      },
      {
        name: '强制加单',
        path: 'add',
        component: _import('dispatch/add/index'),
        hidden: true,
        meta: {
          title: '强制加单',
          icon: 'dingdan',
          hoverIcon: 'dingdan-h',
        },
        menu: 'dispatchAdd'
      },
      {
        name: '新增加单',
        path: 'add/new',
        component: _import('dispatch/add/new'),
        hidden: true
      },
      {
        name: '抢单监控',
        path: 'grab',
        component: _import('dispatch/grab/index'),
        hidden: true,
        meta: {
          title: '抢单监控',
          icon: 'grab',
          hoverIcon: 'grab-h',
        },
        menu: 'dispatchGrab'
      },
      {
        name: '抢单详情',
        path: 'grab/detail/:id',
        component: _import('dispatch/grab/detail'),
        hidden: true,
        meta: {
          title: '抢单详情',
        }
      },
      {
        name: '强制派单',
        path: 'force',
        component: _import('dispatch/force/index'),
        hidden: true,
        meta: {
          title: '强制派单',
          icon: 'force',
          hoverIcon: 'force-h',
        },
        menu: 'dispatchForce'
      },
      {
        name: '强制派单详情',
        path: 'force/detail/:id',
        component: _import('dispatch/force/detail'),
        hidden: true,
        meta: {
          title: '强制派单详情',
        }
      },
    ]
  },
  {
    name: "监控中心",
    path: '/monitor',
    component: Layout,
    meta: {
      icon: 'fangda',
      hoverIcon: 'fangda-h',
    },
    allowShow: true,
    children: [
      {
        name: '实时车辆地图',
        path: 'map',
        component: _import('monitor/map/index'),
        meta: {
          title: '实时车辆地图',
          icon: 'fangda',
          hoverIcon: 'fangda-h',
        },
        menu: 'monitorMap'
      },
      {
        name: '历史轨迹回放',
        path: 'track',
        component: _import('monitor/track/index'),
        meta: {
          title: '历史轨迹回放',
          icon: 'cheliangxinxi',
          hoverIcon: 'cheliangxinxi-h',
        },
        menu: 'monitorTrack'
      },
      {
        name: '点位管理',
        path: 'poi',
        component: _import('monitor/poi/index'),
        meta: {
          title: '点位管理',
          icon: 'zuzhiguanli',
          hoverIcon: 'zuzhiguanli-h',
        },
        menu: 'monitorPoi'
      },
    ]
  },
  {
    name: "在线车辆",
    path: '/vehicle',
    component: Layout,
    hidden: true,
    children: [
      {
        name: '在线车辆页',
        path: 'online',
        component: _import('vehicle/online/index'),
        meta: {
          title: '在线车辆',
        },
      },
      {
        name: '在途车辆页',
        path: 'transit',
        component: _import('vehicle/transit/index'),
        meta: {
          title: '在途车辆',
        },
      },
    ]
  },
  {
    name: "空闲司机",
    path: '/driver',
    component: Layout,
    hidden: true,
    children: [
      {
        name: '空闲司机页',
        path: 'idle',
        component: _import('driver/idle/index'),
        meta: {
          title: '空闲司机',
        },
      },
    ]
  },
  {
    name: "异常处理",
    path: '/exception',
    component: Layout,
    meta: {
      icon: 'shenhe',
      hoverIcon: 'shenhe-h',
    },
    allowShow: true,
    children: [
      {
        name: '轨迹异常挂起',
        path: 'track',
        component: _import('exception/track/index'),
        hidden: true,
        meta: {
          title: '轨迹异常挂起',
          icon: 'shenhe',
          hoverIcon: 'shenhe-h',
        },
        menu: 'exceptionTrack'
      },
      {
        name: '拒单记录',
        path: 'reject',
        component: _import('exception/reject/index'),
        meta: {
          title: '拒单记录',
          icon: 'dingdan',
          hoverIcon: 'dingdan-h',
        },
        menu: 'exceptionReject'
      },
      {
        name: '信用记录',
        path: 'credit',
        component: _import('exception/credit/index'),
        hidden: true,
        meta: {
          title: '信用记录',
          icon: 'tongji',
          hoverIcon: 'tongji-h',
        },
        menu: 'creditRecord'
      },
    ]
  },
  {
    name: "统计分析",
    path: '/stats',
    component: Layout,
    hidden: true,
    meta: {
      icon: 'tongji',
      hoverIcon: 'tongji-h',
    },
    allowShow: true,
    children: [
      {
        name: '综合调度看板',
        path: 'dispatch',
        component: _import('stats/dispatch/index'),
        meta: {
          title: '综合调度看板',
          icon: 'tongji',
          hoverIcon: 'tongji-h',
        },
        menu: 'statsDispatch'
      },
      {
        name: '运营效率看板',
        path: 'operation',
        component: _import('stats/operation/index'),
        meta: {
          title: '运营效率看板',
          icon: 'shuju',
          hoverIcon: 'shuju-h',
        },
        menu: 'statsOperation'
      },
      {
        name: '绩效/工时看板',
        path: 'performance',
        component: _import('stats/performance/index'),
        meta: {
          title: '绩效/工时看板',
          icon: 'shuju',
          hoverIcon: 'shuju-h',
        },
        menu: 'statsPerformance'
      },
    ]
  },
  {
    name: "结算中心",
    path: '/settlement',
    component: Layout,
    meta: {
      icon: 'guanli',
      hoverIcon: 'guanli-h',
    },
    allowShow: true,
    children: [
      {
        name: '工时统计',
        path: 'workTime',
        component: _import('settlement/workTime/index'),
        meta: {
          title: '工时统计',
          icon: 'tongji',
          hoverIcon: 'tongji-h',
        },
        menu: 'workTime'
      },
      {
        name: '工时详情',
        path: 'workTime/detail/:driverId/:month',
        component: _import('settlement/workTime/detail'),
        hidden: true,
        meta: {title: '工时详情'}
      },
      {
        name: '编辑工时',
        path: 'workTime/edit/:driverId/:month',
        component: _import('settlement/workTime/edit'),
        hidden: true,
        meta: {title: '编辑工时'}
      },
      {
        name: '工时规则',
        path: 'workHourStandard',
        component: _import('settlement/workHourStandard/index'),
        meta: {
          title: '工时规则',
          icon: 'peizhi',
          hoverIcon: 'peizhi-h',
        },
        menu: 'workHourStandard'
      },
      {
        name: '工时计算配置',
        path: 'workHourCalc',
        component: _import('settlement/workHourCalc/index'),
        meta: {
          title: '工时计算配置',
          icon: 'peizhi',
          hoverIcon: 'peizhi-h',
        },
        menu: 'workHourCalc'
      },
    ]
  },
  {
    name: "系统设置",
    path: '/system',
    component: Layout,
    meta: {
      icon: 'peizhi',
      hoverIcon: 'peizhi-h',
    },
    children: [
      {
        name: '字典类型',
        path: 'dict/dictType',
        component: _import('dict/dictType/index'),
        meta: {
          title: '字典类型',
          icon: 'zidian',
          hoverIcon: 'zidian-h',
        },
        menu: 'dictType'
      },
      {
        name: '字典项',
        path: 'dict/dictItem',
        component: _import('dict/dictItem/index'),
        meta: {
          title: '字典项',
          icon: 'zhengjianguanli',
          hoverIcon: 'zhengjianguanli-h',
        },
        menu: 'dictItem'
      },
      {
        name: '车型分类',
        path: 'vehicleCategory',
        component: _import('vehicleCategory/index'),
        meta: {
          title: '车型分类',
          icon: 'vehicleCategory',
          hoverIcon: 'vehicleCategory-h',
        },
        menu: 'vehicleCategory'
      },
      {
        name: '车型介质配置',
        path: 'vehicleMedium',
        component: _import('vehicleMedium/index'),
        meta: {
          title: '车型介质配置',
          icon: 'yanfawuliao2',
          hoverIcon: 'yanfawuliao2-h',
        },
        menu: 'vehicleMedium'
      },
      {
        name: '系统日志',
        path: 'sysLog',
        component: _import('sysLog/index'),
        meta: {
          title: '系统日志',
          icon: 'jilu',
          hoverIcon: 'jilu-h',
        },
        menu: 'sysLog'
      },
      {
        name: '系统派单日志',
        path: 'autoDispatchLog',
        component: _import('autoDispatchLog/index'),
        meta: {
          title: '系统派单日志',
          icon: 'jilu',
          hoverIcon: 'jilu-h',
        },
        menu: 'autoDispatchLog'
      },
      {
        name: '派单规则设置',
        path: 'dispatchRule',
        component: _import('dispatchrule/index'),
        meta: {
          title: '派单规则设置',
          icon: 'paidan',
          hoverIcon: 'paidan-h',
        },
        menu: 'dispatchRule'
      },
      {
        name: '通知提醒设置',
        path: 'notifications',
        component: _import('notification/index'),
        meta: {
          title: '通知提醒设置',
          icon: 'tongzhi',
          hoverIcon: 'tongzhi-h',
        },
        menu: 'notifications'
      },
      {
        name: '语音通知设置',
        path: 'nightDuty',
        component: _import('nightduty/index'),
        meta: {
          title: '语音通知设置',
          icon: 'yezhiban',
          hoverIcon: 'yezhiban-h',
        },
        menu: 'nightDuty'
      },
      {
        name: '业务类型配置',
        path: 'businessType',
        component: _import('businessType/index'),
        meta: {
          title: '业务类型配置',
          icon: 'shuju',
          hoverIcon: 'shuju-h',
        },
        menu: 'businessType'
      },
      {
        name: '车检模板配置',
        path: 'inspectionTemplate',
        component: _import('inspectionTemplate/index'),
        meta: {
          title: '车检模板配置',
          icon: 'cheliangdangan',
          hoverIcon: 'cheliangdangan-h',
        },
        menu: 'inspectionTemplate'
      },
    ]
  },
]
export default new Router({
  //mode: 'history', //后端支持可开
  //base:'/dist/',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js